import {
    TEETIME_SELECTED,
    CANCEL_SELECTED_TEETIME,
    TEETIME_GOLFERCOUNT_SELECTED,
    RESERVATION_PLACED,
    GOLFERCOUNT_UPDATE,
    CREATE_RESERVATION,
    RESERVATION_FAILED,
    TEETIME_UNAVAILIBLE,
    UNSET_TEETIME_UNAVAILIBLE_ERROR,
    SHOW_GOLFER_MODAL,
} from '../actions';


const defaultState = {
    teetime: null,
    golfers: null,
    showSelectGolfersModal: false,
    fetchingReservation: false,
    teetimeUnavailibleError: false,
}

// unset teetimeUnavailibleError
const unsetTTUError = obj => ({ ...obj, teetimeUnavailibleError: false });

function selectedTeeTime(state = defaultState, action) {
    switch (action.type) {
        case TEETIME_SELECTED: {
            return unsetTTUError({ ...state, teetime: action.payload });
        }
        case SHOW_GOLFER_MODAL: {
            return unsetTTUError({ ...state, showSelectGolfersModal: true });
        }
        case TEETIME_UNAVAILIBLE: {
            return { ...defaultState, golfers: state.golfers, teetimeUnavailibleError: true }
        }
        case UNSET_TEETIME_UNAVAILIBLE_ERROR: {
            return unsetTTUError({ ...state })
        }
        case CANCEL_SELECTED_TEETIME: {
            return { ...defaultState }
        }
        case TEETIME_GOLFERCOUNT_SELECTED: {
            return unsetTTUError({ ...state, golfers: action.payload });
        }
        case GOLFERCOUNT_UPDATE: {
            return unsetTTUError({ ...state, golfers: action.payload, showSelectGolfersModal: false });
        }
        case CREATE_RESERVATION: {
            return unsetTTUError({ ...state, fetchingReservation: true })
        }
        case RESERVATION_FAILED: {
            return unsetTTUError({ ...state, fetchingReservation: false })
        }
        case RESERVATION_PLACED: {
            return unsetTTUError({ ...state, showSelectGolfersModal: false, fetchingReservation: false })
        }
        default:
            return state;
    }
}

export default selectedTeeTime


// WEBPACK FOOTER //
// ./src/reducers/selectedteetime.js